import { render, staticRenderFns } from "./ServiceConfig.vue?vue&type=template&id=2a89d76f&"
import script from "./ServiceConfig.vue?vue&type=script&lang=js&"
export * from "./ServiceConfig.vue?vue&type=script&lang=js&"
import style0 from "./ServiceConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports